export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0142"] = "acq-0142";
  ExperimentKeys["ACQ0143"] = "acq-0143";
  ExperimentKeys["ACQ0144"] = "acq-0144";
  ExperimentKeys["WP0078"] = "wp-0078";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';